/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":".dropdownExample{max-width:300px}.dropdownExample-option{display:-webkit-box;display:-ms-flexbox;display:flex}.dropdownExample-placeholder{display:-webkit-box;display:-ms-flexbox;display:flex}"}]);
/* tslint:enable */